import { gql, useQuery } from '@apollo/client';
import { Box, Button, Center, Text } from '@chakra-ui/react';
import * as React from 'react';

import {
  PostingExperience,
  usePostingExperience,
} from '@/components/PostingExperience';
import { Card } from '@/imports/ui/chakra/components/Card';

import {
  NoPosts_GroupQuery,
  NoPosts_GroupQueryVariables,
} from './graphql-types/NoPosts_GroupQuery';

const PERMISSION_QUERY = gql`
  query NoPosts_GroupQuery($input: GroupInput!) {
    group(input: $input) {
      result {
        _id
        currentUserGroupLink {
          _id
        }
      }
    }
  }
`;

export const NoPosts: React.FC<{
  organization?: { _id: string };
  group?: { _id: string };
  tags?: { _id: string; name: string }[];
}> = ({ organization, group, tags }) => {
  const { data, loading } = useQuery<
    NoPosts_GroupQuery,
    NoPosts_GroupQueryVariables
  >(PERMISSION_QUERY, {
    variables: { input: { _id: group?._id } },
    skip: !group,
  });
  const postingExperience = usePostingExperience();

  return (
    <Card>
      <Center h={96}>
        <Box textAlign="center" p="4">
          <Text fontWeight="semibold" color="gray.700">
            There are no discussions on the feed yet
          </Text>
          {loading ||
          (!!data?.group.result?._id &&
            !data.group.result.currentUserGroupLink?._id) ? null : (
            <>
              <Text color="gray.600">
                Get the conversation started by creating the first community
                discussion!
              </Text>
              <Button mt="4" onClick={postingExperience.createPost}>
                Start a Discussion
              </Button>
            </>
          )}
        </Box>
      </Center>
      <PostingExperience
        {...postingExperience}
        options={{ tags, organization, group }}
      />
    </Card>
  );
};
